// @ts-nocheck

import { __ } from '../../../i18n/l10n';
import { BoomBasketErrorCodes } from '../types/errorCode';
import { BoomSkinIds } from '../types/global';
import { type BoomSkinId } from '../types/global';

export const getBoomOpeNameBySkinId = (skinId: BoomSkinId) =>
  new Proxy(
    {
      [BoomSkinIds.HALLOWEEN]: __('Halloween'),
      [BoomSkinIds.PATRICK]: __('St Patrick'),
      [BoomSkinIds.VALENTINE]: __('St Valentine'),
    },
    {
      get(origin, key) {
        if (!origin[key]) {
          return '';
        }
        return origin[key];
      },
    },
  )[skinId];

// __('Bet is not eligible for Boom %1$s because the game is not in progress')
// __('Bet is not eligible for Boom %1$s because you have not started the game')
// __('The bet is not eligible for Boom %1$s because Freebets are not taken into account')
// __('Bet is not eligible for Boom %1$s because system bets are not eligible')
// __('Bet is not eligible for Boom %1$s because you have already placed an eligible bet on the same match')
// __('Bet is not eligible for Boom %1$s because the match starts in over 48 hours')
// __('Bet is not eligible for Boom %1$s')
// __('Boom %1$s internal error')
// __('Bet is not eligible for Boom %1$s because at least one match starts after the end of the game')
// __('You are currently ineligible for Boom %1$s')
// __('Bet is not eligible for Boom %1$s because you have a bet in the validation process')
export const getBoomErrorLabelsByErrorCode = (skinId: BoomSkinId) => {
  const opeName = getBoomOpeNameBySkinId(skinId);

  return new Proxy(
    {
      [BoomBasketErrorCodes.E_OP_NOT_RUNNING]: __(
        'Bet is not eligible for Boom %1$s because the game is not in progress',
        opeName,
      ),
      [BoomBasketErrorCodes.E_USER_NOT_IN]: __(
        'Bet is not eligible for Boom %1$s because you have not started the game',
        opeName,
      ),
      [BoomBasketErrorCodes.E_FREEBET_FORBIDDEN]: __(
        'The bet is not eligible for Boom %1$s because Freebets are not taken into account',
        opeName,
      ),
      [BoomBasketErrorCodes.E_SYSTEM_FORBIDDEN]: __(
        'Bet is not eligible for Boom %1$s because system bets are not eligible',
        opeName,
      ),
      [BoomBasketErrorCodes.E_MATCH_PENDING]: __(
        'Bet is not eligible for Boom %1$s because you have already placed an eligible bet on the same match',
        opeName,
      ),
      [BoomBasketErrorCodes.E_START_DATE_OVER_48]: __(
        'Bet is not eligible for Boom %1$s because the match starts in over 48 hours',
        opeName,
      ),
      [BoomBasketErrorCodes.E_BETSLIP_NOT_ELIGIBLE]: __('Bet is not eligible for Boom %1$s', opeName),
      [BoomBasketErrorCodes.E_INTERNAL_ERROR]: __('Boom %1$s internal error', opeName),
      [BoomBasketErrorCodes.E_START_DATE_OVER_OPE]: __(
        'Bet is not eligible for Boom %1$s because at least one match starts after the end of the game',
        opeName,
      ),
      [BoomBasketErrorCodes.E_WRONG_ADVENTURE]: __('Bet is not eligible for Boom %1$s', opeName),
      [BoomBasketErrorCodes.E_USER_EXCLUDED]: __('You are currently ineligible for Boom %1$s', opeName),
      [BoomBasketErrorCodes.E_ALREADY_PAID]: __('You have already received your reward'),
      [BoomBasketErrorCodes.E_PAYMENT_ERROR]: __('Error whilst crediting your reward'),
      [BoomBasketErrorCodes.E_ALREADY_REGISTERED]: __('Your participation in the game has already been validated'),
      [BoomBasketErrorCodes.E_RMJ_30]: __('!desc:%1$s ES RM J-30 warning', 'Atención:'),
      [BoomBasketErrorCodes.E_SELF_EXCLUDED]: __(
        'You are currently excluded from Boom %1$s due to your game limits',
        opeName,
      ),
      [BoomBasketErrorCodes.E_LICENSE_NOT_FOUND]: __('Boom %1$s internal error', opeName),
      [BoomBasketErrorCodes.E_STEP_PENDING]: __(
        'Bet is not eligible for Boom %1$s because you have a bet in the validation process',
        opeName,
      ),
    },
    {
      get(origin, key) {
        if (!origin[key]) {
          return __('An error has occured');
        }
        return origin[key];
      },
    },
  );
};
